import React from 'react'

import isAfter from 'date-fns/isAfter'
import Container from 'components/atoms/Container'
import Typography from 'components/atoms/Typography'

import config from 'config'

const { assets_url: assetsUrl } = config
const peluangAssetsPath = `${assetsUrl}/assets/img/peluang`

const PeluangFooter = () => {
  const afterTest = isAfter(new Date(), new Date(2021, 2, 24))
  return (
    <div className="peluang-footer">
      {afterTest && (
        <Container>
          <Typography component="h2" variant="title" className="variant-title-sm m-b-0">
            Tunggu kehadiran Cek Peluang berikutnya!
          </Typography>
        </Container>
      )}
      <style jsx>
        {`
          .peluang-footer {
            padding-bottom: 345px;
            background-repeat: no-repeat;
            background-position: center bottom;
            background-image: url('${peluangAssetsPath}/footer.png');
            text-align: center;
            @media screen and (max-width: 767px) {
              padding-bottom: 120px;
              background-repeat: no-repeat;
              background-position: center bottom;
              background-image: url('${peluangAssetsPath}/footer-sp.png');
            }
          }
        `}
      </style>
    </div>
  )
}

export default PeluangFooter
